// Prioridade: URL completa definida no ambiente (Vercel)
// Se não houver, monta com base no IP e Porta
const getApiUrl = () => {
    if (process.env.REACT_APP_API_URL) {
        let apiUrl = process.env.REACT_APP_API_URL;
        if (apiUrl.includes(',')) {
            const urls = apiUrl.split(',').map(u => u.trim());
            const currentDomain = window.location.hostname.replace('www.', '');
            const matchedUrl = urls.find(u => u.includes(currentDomain));
            apiUrl = matchedUrl || urls[0];
        }
        return apiUrl;
    }

    let envHost = process.env.REACT_APP_SERVER_IP;
    let host;

    if (envHost) {
        if (envHost.includes(',')) {
            const hosts = envHost.split(',').map(h => h.trim());
            const currentDomain = window.location.hostname.replace(/^www\./, '');
            
            // Procura um host na lista que corresponda ao domínio atual da aplicação
            const matchedHost = hosts.find(h => h.includes(currentDomain));
            host = matchedHost || hosts[0];
        } else {
            host = envHost;
        }
    } else {
        host = window.location.hostname;
    }
    
    const port = process.env.REACT_APP_API_PORT || '5000';
    
    // Se o host já contém protocolo, não adiciona http://
    // Se for localhost usa http, caso contrário usa https
    const protocol = host.includes('://') || host.startsWith('http') ? '' : (host.includes('localhost') ? 'http://' : 'https://');
    
    // Se estamos em um domínio (produção), geralmente não usamos porta explícita (o Nginx cuida disso)
    const isDomain = host.includes('.') && !/^[0-9.]+$/.test(host);
    const portSuffix = isDomain ? '' : `:${port}`;
    
    // Corrige erro de digitação comum nas variáveis de ambiente como https// em vez de https://
    let finalUrl = `${protocol}${host}${portSuffix}`;
    finalUrl = finalUrl.replace('https//', 'https://').replace('http//', 'http://');
    
    return finalUrl;
};

export const API_URL = getApiUrl();
export const BASE_URL = API_URL.replace(/\/api\/?$/, '');

// Para exportar o SERVER_IP de forma compatível
let envServerIp = process.env.REACT_APP_SERVER_IP;
let parsedServerIp;
if (envServerIp && envServerIp.includes(',')) {
    const ips = envServerIp.split(',').map(h => h.trim());
    const currentDomain = window.location.hostname.replace(/^www\./, '');
    const matchedIp = ips.find(h => h.includes(currentDomain));
    parsedServerIp = matchedIp || ips[0];
} else {
    parsedServerIp = envServerIp;
}

export const SERVER_IP = parsedServerIp || window.location.hostname;
export const API_PORT = process.env.REACT_APP_API_PORT || '5000';